module.exports = __webpack_public_path__ + "e-learning-app/static/img/dang.e879a18.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/dang.png
// module id = VcUh
// module chunks = 1